module.exports = __webpack_public_path__ + "img/pay.559ed279.png";